// removed by extract-text-webpack-plugin
module.exports = {"pgx-form-item":"pgx-form-item","ant-form-item":"ant-form-item","legitimacyTip":"legitimacyTip","warning":"warning","ant-form-item-label":"ant-form-item-label","ant-form-item-control-wrapper":"ant-form-item-control-wrapper","ant-form-item-control":"ant-form-item-control"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/MaterialFormItem/materialFormItem.scss
// module id = 918
// module chunks = 0